module.exports = __webpack_public_path__ + "img/lg_head.1c983a8a.gif";